// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__u86mV","select":"Header_select__1D9kf","clinic":"Header_clinic__3ZVqn"};